import { owcTheme } from 'core/theme/theme.config';
import { PocComponentHeader } from 'commons/components/components-wrapper/poc-component-header.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { Input, Select } from 'commons/components';
import { SettingsCardLayout } from 'modules/settings/settings.style';
import styled, { css } from 'styled-components';

export const ActiveDirectoryConnectionDetailsFormFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const SettingsCardLayoutStyled = styled(SettingsCardLayout)`
    width: 100%;
`;

export const PocComponentHeaderStyled = styled(PocComponentHeader)`
    padding-right: 20px;

    /* v7 defaults owc-component-header to flex-wrap: wrap, so the suffix button (Edit /
       Test connection) drops to a second line under the title; keep it on the right. */
    flex-wrap: nowrap !important;
`;

export const OwcComponentHeaderSuffixWrapperStyled = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;

    /* OWC-OVERRIDE: v7 shrinks header-suffix buttons to min-content, wrapping labels like
       "Test connection" onto two lines; keep them on one line. owc-button wraps its label on
       the internal content wrapper in v7.6.0 and exposes no nowrap or width prop. */
    owc-button .owc-button__content-wrapper {
        white-space: nowrap;
    }
`;

export const ActiveDirectoryConnectionDetailsFormHeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ActiveDirectoryConnectionDetailsFormHeaderTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
`;

export const LastSyncPocTypography = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

// Styles to align form components due to AssertiveText issue
const alignedFormComponentStyles = css`
    owc-input {
        margin-top: 16px;
    }
`;
export const InputStyled = styled(Input)`
    ${alignedFormComponentStyles}
`;

export const SelectStyled = styled(Select)`
    ${alignedFormComponentStyles}
`;
